export default {
  root: {
    height: '56px',
    '&$selected': {
      backgroundColor: '#f8fafc'
    },
    '&$hover': {
      '&:hover': {
        backgroundColor: '#f8fafc'
      }
    }
  }
};
